/*
 * My Blaster page. Markup and the server-side data (bought blasters with their specs,
 * buy-again handles) in sections/gbu-my-blaster.liquid.
 *
 * Blasters = the ones bought from us (from the page data) + the one saved in Upgrade Your
 * Blaster (localStorage 'gbu-ugb-blaster'), one per compatibility collection, shown as a
 * garage strip. For the chosen blaster: a spotlight card (photo, when bought, specs, shop
 * buttons), category tabs with counts, and one grid of the store's own product cards.
 *
 * What fits comes from the blaster's compatibility collection through the ugb-data view
 * (templates/collection.ugb-data.liquid: in-stock products tagged parts / accessories /
 * gels). Cards are fetched one by one as /products/<handle>?view=gbu-rv - the same cards
 * as You may also like and Recently viewed.
 */
(function () {
  if (window.__gbuMb) return;
  window.__gbuMb = true;

  var SAVED_KEY = 'gbu-ugb-blaster';
  var PER_TAB = 12;
  var GREEN_TICK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 13l4.5 4.5L19 8"/></svg>';

  var root, data, selected = null, tab = null;
  var cardCache = {};
  var feedCache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function saved() {
    try {
      var v = JSON.parse(localStorage.getItem(SAVED_KEY) || 'null');
      return v && v.handle ? v : null;
    } catch (e) {
      return null;
    }
  }
  /** "M4A1 V8 - Gel Blaster" -> "M4A1 V8": the suffix every blaster title carries. */
  function shortName(n) {
    return String(n || '').replace(/\s*[-–]\s*gel\s*blaster.*$/i, '').replace(/\s{2,}/g, ' ').trim() || n;
  }
  function handleOf(url) {
    var tail = String(url || '').split('/products/')[1];
    return tail ? tail.split(/[?#]/)[0] : null;
  }

  /** Bought blasters first (newest order first), then the saved one if it is not already there. */
  function blasters() {
    var list = (data.owned || []).map(function (b) {
      return { compat: b.compat, name: b.name, image: b.image, url: b.url, fps: b.fps, power: b.power, build: b.build, label: 'Bought ' + b.bought, kind: 'owned' };
    });
    var s = saved();
    if (s && !list.some(function (b) { return b.compat === s.handle; })) {
      list.push({ compat: s.handle, name: s.name, image: s.image ? sized(s.image, 600) : null, label: 'Saved by you', kind: 'saved' });
    }
    return list;
  }

  // ---- data ---------------------------------------------------------------------------

  /** One blaster's in-stock compatible products, sorted into the tabs. Loaded once. */
  function feed(compat) {
    if (!feedCache[compat]) {
      feedCache[compat] = fetch('/collections/' + encodeURIComponent(compat) + '?view=ugb-data&filter.v.availability=1')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = d.products || [];
          var mags = ps.filter(function (p) { return p.kind === 'accessories' && /\bmag(azine)?s?\b|drum/i.test(p.title); });
          return {
            total: ps.length,
            tabs: [
              { key: 'parts', label: 'Upgrades', list: ps.filter(function (p) { return p.kind === 'parts'; }) },
              { key: 'mags', label: 'Magazines', list: mags },
              { key: 'acc', label: 'Accessories', list: ps.filter(function (p) { return p.kind === 'accessories' && mags.indexOf(p) === -1; }) },
              { key: 'gels', label: 'Gels & gas', list: ps.filter(function (p) { return p.kind === 'gels'; }) },
            ],
          };
        })
        .catch(function (e) {
          delete feedCache[compat];
          throw e;
        });
    }
    return feedCache[compat];
  }

  /** The store's own card for one product. */
  function card(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=gbu-rv', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var item = doc.querySelector('[data-gbu-rv-card]');
          if (item) loadScripts(doc.querySelectorAll('script[src]'));
          return item;
        })
        .catch(function () { return null; });
    }
    return cardCache[handle];
  }

  function loadScripts(nodes) {
    Array.prototype.forEach.call(nodes, function (s) {
      var src = s.getAttribute('src');
      if (!src) return;
      var path = src.split('?')[0].replace(/^https?:/, '');
      if (Array.prototype.some.call(document.scripts, function (x) { return x.src && x.src.indexOf(path) !== -1; })) return;
      var tag = document.createElement('script');
      tag.src = src;
      if (s.type) tag.type = s.type;
      document.head.appendChild(tag);
    });
  }

  /** Fill a grid with cards for these handles, in order. Resolves to how many showed. */
  function fill(grid, handles, stillWanted) {
    grid.innerHTML = '';
    grid.classList.add('is-loading');
    return Promise.all(handles.map(card)).then(function (items) {
      if (stillWanted && !stillWanted()) return 0;
      grid.classList.remove('is-loading');
      var n = 0;
      items.forEach(function (it) {
        if (!it) return;
        grid.appendChild(document.importNode(it, true));
        n++;
      });
      return n;
    });
  }

  // ---- the garage ---------------------------------------------------------------------

  function drawGarage() {
    var wrap = root.querySelector('[data-gbu-mb-blasters]');
    var list = blasters();
    if (!selected || !list.some(function (b) { return b.compat === selected; })) selected = list.length ? list[0].compat : null;
    root.querySelector('[data-gbu-mb-count]').textContent = list.length ? list.length + (list.length === 1 ? ' blaster' : ' blasters') : '';

    wrap.innerHTML = list.map(function (b) {
      var on = b.compat === selected;
      return '<div class="gbu-mb__tile' + (on ? ' is-on' : '') + '" role="listitem">' +
        '<button type="button" class="gbu-mb__pick" data-gbu-mb-pick="' + esc(b.compat) + '" aria-pressed="' + on + '">' +
        '<span class="gbu-mb__tile-media">' +
        (b.image ? '<img src="' + esc(b.image) + '" alt="" loading="lazy" width="600" height="450">' : '') +
        '<span class="gbu-mb__tick" aria-hidden="true">' + GREEN_TICK + '</span>' +
        '</span>' +
        '<span class="gbu-mb__tile-body">' +
        '<span class="gbu-mb__chip gbu-mb__chip--' + b.kind + '">' + esc(b.label) + '</span>' +
        '<span class="gbu-mb__tile-name">' + esc(shortName(b.name)) + '</span>' +
        '<span class="gbu-mb__tile-fits" data-gbu-mb-fitcount="' + esc(b.compat) + '">&nbsp;</span>' +
        '</span></button>' +
        (b.kind === 'saved' ? '<button type="button" class="gbu-mb__forget" data-gbu-mb-forget aria-label="Remove ' + esc(b.name) + '">&times;</button>' : '') +
        '</div>';
    }).join('') +
      '<div class="gbu-mb__tile gbu-mb__tile--add" role="listitem">' +
      '<button type="button" class="gbu-mb__pick" data-ugb-open="pick">' +
      '<span class="gbu-mb__add-ico" aria-hidden="true">+</span>' +
      '<span class="gbu-mb__tile-name">Add a blaster</span>' +
      '<span class="gbu-mb__add-sub">Bought one somewhere else? Add it to see what fits.</span>' +
      '</button></div>';

    // How many in-stock products fit each blaster, on its tile.
    list.forEach(function (b) {
      feed(b.compat).then(function (f) {
        var el = wrap.querySelector('[data-gbu-mb-fitcount="' + CSS.escape(b.compat) + '"]');
        if (el) el.textContent = f.total ? f.total + ' in stock that fit' : 'Nothing in stock right now';
      }).catch(function () {});
    });

    root.querySelector('[data-gbu-mb-signin]').hidden = !!data.signedIn;
    drawFits(list.filter(function (b) { return b.compat === selected; })[0]);
  }

  // ---- the chosen blaster ---------------------------------------------------------------

  function specPills(b) {
    var out = [];
    var fps = String(b.fps || '').trim();
    if (fps && !/^n\/?a$/i.test(fps)) out.push('<span class="gbu-mb__pill gbu-mb__pill--fps">' + esc(fps) + '</span>');
    if (b.power) out.push('<span class="gbu-mb__pill">' + esc(b.power) + '</span>');
    if (b.build) out.push('<span class="gbu-mb__pill">' + esc(b.build) + '</span>');
    return out.join('');
  }

  function drawFits(b) {
    var box = root.querySelector('[data-gbu-mb-fits]');
    if (!b) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    var spot = root.querySelector('[data-gbu-mb-spot]');
    var collUrl = '/collections/' + encodeURIComponent(b.compat);
    spot.innerHTML =
      '<span class="gbu-mb__spot-media">' + (b.image ? '<img src="' + esc(b.image) + '" alt="' + esc(b.name) + '" width="600" height="450">' : '') + '</span>' +
      '<span class="gbu-mb__spot-body">' +
      '<span class="gbu-mb__chip gbu-mb__chip--' + b.kind + '">' + esc(b.label) + '</span>' +
      '<span class="gbu-mb__spot-kicker">Upgrades for your</span>' +
      '<span class="gbu-mb__spot-name">' + esc(shortName(b.name)) + '</span>' +
      '<span class="gbu-mb__pills">' + specPills(b) + '</span>' +
      '<span class="gbu-mb__actions">' +
      '<a class="gbu-mb__btn gbu-mb__btn--green" data-gbu-mb-shopall href="' + esc(collUrl) + '">Shop everything that fits</a>' +
      (b.url ? '<a class="gbu-mb__btn gbu-mb__btn--ghost" href="' + esc(b.url) + '">View blaster</a>' : '') +
      '</span></span>';

    var tabsEl = root.querySelector('[data-gbu-mb-tabs]');
    var grid = root.querySelector('[data-gbu-mb-grid]');
    var status = root.querySelector('[data-gbu-mb-status]');
    var more = root.querySelector('[data-gbu-mb-more]');
    tabsEl.innerHTML = '';
    grid.innerHTML = '';
    more.hidden = true;
    status.hidden = false;
    status.textContent = 'Finding what fits…';

    feed(b.compat).then(function (f) {
      if (selected !== b.compat) return;
      var shop = spot.querySelector('[data-gbu-mb-shopall]');
      if (f.total) shop.textContent = 'Shop all ' + f.total + ' that fit';
      var tabs = f.tabs.filter(function (t) { return t.list.length; });
      if (!tabs.length) {
        status.innerHTML = 'Nothing that fits is in stock right now. <a href="' + esc(collUrl) + '">See the full range</a>.';
        return;
      }
      status.hidden = true;
      if (!tab || !tabs.some(function (t) { return t.key === tab; })) tab = tabs[0].key;
      tabsEl.innerHTML = tabs.map(function (t) {
        var on = t.key === tab;
        return '<button type="button" role="tab" class="gbu-mb__tab' + (on ? ' is-on' : '') + '" aria-selected="' + on + '" data-gbu-mb-tab="' + t.key + '">' +
          esc(t.label) + ' <span class="gbu-mb__tab-n">' + t.list.length + '</span></button>';
      }).join('');
      var t = tabs.filter(function (x) { return x.key === tab; })[0];
      var compat = b.compat, key = t.key;
      fill(grid, t.list.slice(0, PER_TAB).map(function (p) { return handleOf(p.url); }).filter(Boolean), function () { return selected === compat && tab === key; });
      if (t.list.length > PER_TAB) {
        more.hidden = false;
        more.innerHTML = '<a class="gbu-mb__btn gbu-mb__btn--ghost" href="' + esc(collUrl) + '">See all ' + t.list.length + ' ' + esc(t.label.toLowerCase()) + '</a>';
      }
    }).catch(function () {
      status.innerHTML = 'We couldn&rsquo;t load the parts just now. <a href="' + esc(collUrl) + '">Open them on their own page</a>.';
    });
  }

  // ---- buy again ------------------------------------------------------------------------

  function drawAgain() {
    var box = root.querySelector('[data-gbu-mb-again]');
    var handles = (data.again || []).slice(0, 6);
    if (!handles.length) return;
    fill(box.querySelector('[data-gbu-mb-again-grid]'), handles).then(function (n) { box.hidden = !n; });

    // One button that adds one of each to the cart they already have (a /cart/... link would
    // replace it and jump to checkout): the first available variant of each.
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var v = p && (p.variants || []).filter(function (x) { return x.available; })[0];
          return v ? v.id : null;
        })
        .catch(function () { return null; });
    })).then(function (ids) {
      ids = ids.filter(Boolean);
      var btn = box.querySelector('[data-gbu-mb-reorder]');
      if (!ids.length || !window.GBUCartSync) return;
      btn.textContent = 'Reorder all ' + ids.length + ' →';
      btn.hidden = false;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding…';
        window.GBUCartSync.add(ids.map(function (id) { return { id: id, quantity: 1 }; }))
          .then(function () { btn.textContent = 'Added ✓'; })
          .catch(function () { btn.textContent = 'Try again'; })
          .then(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }

  function init() {
    root = document.querySelector('[data-gbu-mb]');
    if (!root) return;
    try {
      data = JSON.parse(root.querySelector('[data-gbu-mb-data]').textContent);
    } catch (e) {
      data = { owned: [], again: [] };
    }
    if (data.firstName) root.querySelector('[data-gbu-mb-welcome]').textContent = 'Welcome back, ' + data.firstName;

    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-gbu-mb-pick]');
      if (pick) {
        if (selected !== pick.getAttribute('data-gbu-mb-pick')) {
          selected = pick.getAttribute('data-gbu-mb-pick');
          tab = null;
          drawGarage();
        }
        return;
      }
      var t = e.target.closest('[data-gbu-mb-tab]');
      if (t) {
        tab = t.getAttribute('data-gbu-mb-tab');
        drawFits(blasters().filter(function (b) { return b.compat === selected; })[0]);
        return;
      }
      if (e.target.closest('[data-gbu-mb-forget]')) {
        try { localStorage.removeItem(SAVED_KEY); } catch (err) {}
        document.dispatchEvent(new CustomEvent('ugb:change'));
      }
    });
    // A blaster added or changed in the Upgrade Your Blaster modal (the "Add a blaster" tile).
    document.addEventListener('ugb:change', function () {
      var s = saved();
      if (s) {
        selected = s.handle;
        tab = null;
      }
      drawGarage();
    });

    drawGarage();
    drawAgain();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
